import { Formik } from 'formik';
import pluralize from 'pluralize';
import React, { useRef } from 'react';
import * as Yup from 'yup';
import { Field, FixedDayPickerDropdown, FixedSingleSelect, Form } from '~/components';
import BulkActionModal from '~/components/bulk-action/BulkActionModal';
import { useApi, useWorkspace } from '~/contexts';
import { emptyStringToNull } from '~/utils';
import ProjectDetails from './ProjectDetails';

export default function BulkSetStatus({ ids, onClose, onComplete }) {
  const { workspace } = useWorkspace();
  const api = useApi();
  const formRef = useRef();

  return (
    <BulkActionModal
      title="Bulk Set Status"
      onClose={onClose}
      onComplete={onComplete}
      onConfirm={() => formRef.current?.submitForm()}
      renderRow={ProjectDetails}>
      <Formik
        innerRef={formRef}
        initialValues={{ statusId: null, completedOn: null }}
        onSubmit={async (values) => {
          const body = emptyStringToNull(values);
          if (body.statusId !== 'completed') {
            body.completedOn = null;
          }
          return api.www
            .workspaces(workspace.id)
            .projects()
            .bulkSetStatus(ids, body)
            .then((r) => r.data);
        }}
        validateOnBlur={false}
        validateOnChange={false}
        validationSchema={Yup.object().shape({
          statusId: Yup.string().label('Project Status').nullable().required(),
          completedOn: Yup.date()
            .label('Completed On')
            .nullable()
            .when('statusId', { is: 'completed', then: (schema) => schema.required() }),
        })}>
        {(formik) => {
          return (
            <Form>
              <p>
                Set the status of {ids.length} {pluralize('project', ids.length)} to:
              </p>

              <Form.Control>
                <Field.ProjectStatusSelect name="statusId" placeholder="Project Status" component={FixedSingleSelect} />
              </Form.Control>

              {formik.values.statusId === 'completed' && (
                <Form.Control>
                  <Field.DayPicker
                    name="completedOn"
                    placeholder="Completed On"
                    clearable={false}
                    component={FixedDayPickerDropdown}
                  />
                </Form.Control>
              )}
            </Form>
          );
        }}
      </Formik>
    </BulkActionModal>
  );
}
